import WbsCookies from "./modules/WbsCookies";
import WbsTabs from "./modules/WbsTabs";
import WbsAccordion from "./modules/WbsAccordion";
import WbsToggleCookieModal from "./modules/WbsToggleCookieModal";

WbsCookies();

WbsTabs();
WbsAccordion();

const widgetButton = document.getElementById('WbsCookieOpenWidget');

if (widgetButton){
    widgetButton.addEventListener('click', function () {
       WbsToggleCookieModal('show');
    });
}